import { SmartRecommendations } from '../components/SmartRecommendations'

const Recommendations = () => {
  // Using our new SmartRecommendations component
  return <SmartRecommendations />
}

export default Recommendations